<template>
  <div class="fixed right-0 bottom-0  w-400 max-w-full bg-blue-800 text-xs z-30 p-2 cursor-pointer"
       @click="isMinimized = !isMinimized" v-if="$store.state.isDebugBarVisible">
    <div class="logs">
      <div id="sync-wrapper">
        <div v-if="status === 'syncing'">
          <a class="text-green-300">Syncing</a>
        </div>
        <div v-if="status === 'paused'">
          <a class="text-yellow-300">Waiting for changes</a>
        </div>
        <div v-if="status === 'error'">
          <a class="text-red-300">There was a problem syncing</a>
        </div>
      </div>
      <div v-show="isMinimized" class="log" v-for="log in logsToShow" :key='log.timestamp'>
        <p>
          {{[log.timestamp]}} {{log.message}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebugBar',
  data () {
    return {
      isMinimized: false
    }
  },
  computed: {
    logsToShow () {
      let messages = this.$store.state.logs
      return messages.length >= 9
        ? messages.slice(messages.length - 9, messages.length)
        : messages
    }
  }
}
</script>
